import { getApi } from "../util/api";

export async function getPersonaCustomerInfo() {
  const res = await getApi().get("/api/kyc/get-verification");
  return res.data;
}
